import { Modal as Popup } from 'react-bootstrap'

export default function Modal(props) {

    const { show, size, handleClose, header, FormPage, formProps } = props

    return (
        <>
            <Popup
                show={show}
                onHide={handleClose}
                backdrop="static"
                keyboard={false}
                size={size || 'md'}
                centered
            >
                <Popup.Header closeButton className='d-flex justify-content-between align-items-center ps-3 pe-3'>
                    <Popup.Title as='h5' style={{ fontWeight: 700 }}>{header}</Popup.Title>
                </Popup.Header>
                <Popup.Body>
                    {show && FormPage ? <FormPage {...(formProps || {})} /> : null}
                </Popup.Body>
            </Popup>
        </>
    )
}